var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTradeIn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#4A4A4A",
  d: "m26.511 33.335 10.156-8.602L26.51 16.13v3.441h-5.585v-2.238h-12.5v3.065a9 9 0 0 0 8.935 9l9.15.066z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#trade-in_svg__a)",
  fillRule: "evenodd",
  d: "M13.817 6.667 3.334 15.269l5.555 4.066.345.236h.001l4.515 3.096V19.57h12.761v-3.44l5.584 4.729h.067v-1.322a9 9 0 0 0-9-9h-9.345z",
  clipRule: "evenodd"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "trade-in_svg__a",
  x1: 32.037,
  x2: 10.961,
  y1: 9.333,
  y2: 22.081,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F4F8FC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#568DFE"
})))));
export default SvgTradeIn;